<script type="text/javascript">
	import WeatherStore from "./Store";
	import DirectionalArrow from "../UI/DirectionalArrow.svelte";

	export let current = null; // required writable, dont pass with $.
	export let name = "";
	export let key = "";
	export let unitSuffix = ""; // mtrs/sec
	export let showArrow = false; // for degrees
	export let showAll = false;
	export let naValue = "N/A";

	export let transformValue = (v) => { return v; };

	let _GSA = WeatherStore.helpers.getSourceAcronym;
	let _FORMAT = WeatherStore.helpers.formatValue;
	let _FORMAT_TIDE = WeatherStore.helpers.formatTideValue;
</script>


<tr>
	<td>{name}:</td>
	{#if !!$current[key]}
		<td>
			{#if showAll}
				{#each $current[key].options as option}
					{_FORMAT(option.value, unitSuffix, transformValue)} {#if showArrow}<DirectionalArrow adjust={90} degrees={option.value} />{/if}<br/>
				{/each}
			{:else}
				{_FORMAT($current[key].value, unitSuffix, transformValue)} {#if showArrow}<DirectionalArrow adjust={90} degrees={$current[key].value} />{/if}
			{/if}
		</td>
		<td class='data-source'>
			{#if showAll}
				{#each $current[key].options as option}
					<span title={option.source}>{_GSA(option.source)}</span><br/>
				{/each}
			{:else}
				<span title={$current[key].source}>{_GSA($current[key].source)}</span>
			{/if}
		</td>
	{:else}
		<td>{naValue}</td>
	{/if}
</tr>
